require("@babel/polyfill");

import rwxPreload from 'roseworx/js/modules/rwxPreload';
import rwx from 'roseworx';

require('./index.scss');
require('./js/navigation.js');
require('./js/codeBlocks.js');

import Navigation from './js/navigation.js';
Navigation(rwx.sliders);

// paperclip selectors - all headings with ID's / all sections with id's